"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertSizeWithMultiplier = convertSizeWithMultiplier;
/** Take a width, height object return the same object with a multiplier applied. */
function convertSizeWithMultiplier(size, multiplier) {
  return {
    width: size.width * multiplier,
    height: size.height * multiplier
  };
}